module.exports = __webpack_public_path__ + "static/media/Test51.72874ba2.bmp";